import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error if needed
    console.error('Error:', error, 'Error Info:', errorInfo);
  }

  // Method to reset the error state and re-render
  resetErrorBoundary = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      // Render fallback UI
      return (
        <div style={{ padding: '20px', backgroundColor: '#f9f9f9' }}>
          <h3>Something went wrong!</h3>
          <p>Please try again later.</p>
          <Link to={'/bots'}>
            <button>Back</button>
          </Link>
          <button onClick={this.resetErrorBoundary}>Retry</button>
        </div>
      );
    }

    return this.props.children; // Render children if no error
  }
}

export default ErrorBoundary;
